import { Region, Company } from "../../../../models";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Regions extends GetAPI_Base<Region> {
	constructor() {
		super("regions", Region);
	}

	public async byCompany(company: Company) {
		const regions = await super.byFilter({ fields: { companyIds: [company.name] } });
		return regions;
	}
}

export class RegionsAPI extends DataAPI_Base<Region> {
	get: GetAPI_Regions;
	constructor() {
		super("regions", Region);
		this.get = new GetAPI_Regions();
	}
}
